import { useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { useScrollTo } from "../lib/scroll";
import { SITE } from "../constants/site";

const LINKS = [
  { label: "Vision", href: "#vision" },
  { label: "Plans", href: "#plans" },
  { label: "Pricing", href: "#pricing" },
  { label: "Amenities", href: "#amenities" },
  { label: "Gallery", href: "#gallery" },
  { label: "Location", href: "#location" },
];

export default function Navigation() {
  const [open, setOpen] = useState(false);
  const scrollTo = useScrollTo();
  const go = (href) => () => { setOpen(false); scrollTo(href); };

  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-white/70 border-b border-black/5">
      <div className="max-w-screen-2xl mx-auto px-6 h-[72px] flex items-center justify-between">
        <button onClick={go("#top")} data-testid="nav-logo" className="flex items-center gap-3">
          <img src={SITE.logo} alt="Sugee Group" className="h-9 w-auto" />
          <span className="hidden sm:inline text-[10px] uppercase tracking-[0.4em] text-muted-foreground">Lake District · Thane</span>
        </button>
        <nav className="hidden lg:flex items-center gap-9">
          {LINKS.map((l) => (
            <button
              key={l.href}
              onClick={go(l.href)}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-[11px] uppercase tracking-[0.25em] text-muted-foreground hover:text-foreground transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-4">
          <a
            href={`tel:${SITE.phoneRaw}`}
            data-testid="nav-call-link"
            className="hidden xl:flex items-center gap-2 text-[11px] tracking-[0.12em] text-muted-foreground hover:text-primary transition-colors"
          >
            <Phone size={13} className="text-primary" /> {SITE.phoneDisplay}
          </a>
          <button
            onClick={go("#enquire")}
            data-testid="nav-enquire-button"
            className="hidden sm:block bg-primary text-primary-foreground text-[11px] uppercase tracking-[0.25em] px-6 py-3 hover:bg-[#154d8f] transition-colors"
          >
            Enquire Now
          </button>
          <button onClick={() => setOpen(!open)} data-testid="nav-menu-button" className="lg:hidden text-foreground p-2">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden border-t border-black/5 bg-white/95 backdrop-blur-xl px-6 py-6 flex flex-col gap-5">
          {LINKS.map((l) => (
            <button
              key={l.href}
              onClick={go(l.href)}
              data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
              className="text-left text-xs uppercase tracking-[0.25em] text-muted-foreground hover:text-foreground transition-colors"
            >
              {l.label}
            </button>
          ))}
          <button
            onClick={go("#enquire")}
            data-testid="nav-mobile-enquire-button"
            className="bg-primary text-primary-foreground text-[11px] uppercase tracking-[0.25em] px-6 py-3 mt-2"
          >
            Enquire Now
          </button>
        </div>
      )}
    </header>
  );
}
